export enum EOutlineColor {
  OC_NONE,
  OC_USABLE,
  OC_HOLOGRAM,
  OC_RED,
}

export const EOutlineColorDisplayName = {
  [EOutlineColor.OC_NONE]: 'None',
  [EOutlineColor.OC_USABLE]: 'Usable',
  [EOutlineColor.OC_HOLOGRAM]: 'Hologram',
  [EOutlineColor.OC_RED]: 'Disabled',
};
